import { useState } from 'react';

import { DateView } from '@ui/components/DateView';
import { ThemeLink } from '@ui/components/ThemeLink';

import { ClubRulesModal } from '@features/chessrussian/customizations/club-rules/ClubRulesModal';
import { MemberClubDto } from '@features/shared/api/typings';
import { InfoItem } from '@features/shared/ui/InfoItem';
import { InfoBlock } from '@features/shared/ui/InfoItem/InfoItem';

export type Props = {
  club?: MemberClubDto;
  className?: string;
};

export function ClubInfo({ className, club }: Props) {
  const [rulesOpen, setRulesOpen] = useState(false);

  const adminHref = club?.administrator?.email ? 'mailto:' + club?.administrator?.email : undefined;

  const tgHref = club?.telegramChannel ? 'https://t.me/' + club.telegramChannel : undefined;

  return (
    <InfoBlock className={className}>
      <InfoItem label="Клуб создан" value={club && <DateView date={club.createdTimestampMs} />} />
      <InfoItem
        label="Администратор"
        value={<ThemeLink href={adminHref}>{club?.administrator?.fullName}</ThemeLink>}
      />
      {club?.telegramChannel && (
        <InfoItem
          label="Телеграм-канал"
          value={<ThemeLink href={tgHref}>{club?.telegramChannel}</ThemeLink>}
        />
      )}

      {!!club?.rulesConsentRequired && (
        <InfoItem
          label="Правила клуба"
          value={<ThemeLink onClick={() => setRulesOpen(true)}>читать</ThemeLink>}
        />
      )}

      {rulesOpen && <ClubRulesModal onClose={() => setRulesOpen(false)} />}
    </InfoBlock>
  );
}
